module.exports = __webpack_public_path__ + "static/media/YM87_2.ff88ff44.jpg";